var productFrames = {
  white: {
    sizesAvailable: function(size){
      var data = {
        '15x21' : [13500, 30970776132],
        '30x40' : [25000, 30970776196],
        '40x40' : [25000, 47109246031],
        '50x50' : [30000, 47109392847],
        '50x70' : [40000, 30970776324],
        '70x100' : [55000, 30970776388]
      };
      
      return data[''+size+''];
    }
  },
  black: {
    sizesAvailable: function(size){
      var data = {
        '15x21' : [13500, 31161367876],
        '30x40' : [25000, 31161367940],
        '40x40' : [25000, 38558394383],
        '50x50' : [30000, 38558439311],
        '50x70' : [40000, 31161368004],
        '70x100' : [55000, 31161368068]
      };
      
      return data[''+size+''];
    }
  },
  oak: {
    sizesAvailable: function(size){
      var data = {
        '15x21' : [15000, 30972071940],
        '30x40' : [27500, 30972072004],
        '40x40' : [30000, 38558781711],
        '50x50' : [35000, 38558849999],
        '50x70' : [43500, 30972072068]
      };
      
      return data[''+size+''];
    }
  }
}